export { WorkspaceQuotaService } from './services/quota';

import { GraphQLService } from '@affine/core/modules/cloud';
import {
  DocsService,
  type Framework,
  WorkspaceScope,
  WorkspaceService,
} from '@toeverything/infra';

import { WorkspaceQuota } from './entities/quota';
import { QuotaCheckDialog } from './entities/quota-check-dialog';
import { WorkspaceQuotaService } from './services/quota';
import { QuotaCheckDialogService } from './services/quota-check-dialog';
import { WorkspaceQuotaBlobStore } from './stores/blob';
import { WorkspaceQuotaStore } from './stores/quota';

export function configureQuotaModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceQuotaService)
    .store(WorkspaceQuotaStore, [GraphQLService])
    .store(WorkspaceQuotaBlobStore, [GraphQLService])
    .entity(WorkspaceQuota, [
      WorkspaceService,
      WorkspaceQuotaStore,
      DocsService,
      WorkspaceQuotaBlobStore,
    ])
    .service(QuotaCheckDialogService)
    .entity(QuotaCheckDialog);
}
